<div class="row">
  <div class="col-md-12">
    <div mat-dialog-title class="row">
      <div class="col-md-12">
        <h1>
          Your Policy Property Address
        </h1>
        <strong>
          Please confirm that this information is correct:
        </strong>
      </div>
    </div>
    <div mat-dialog-content class="row">
      <div class="col-md-12">
        <div class="row">
          <div class="col-md-12">
            <mat-label>
              <strong>
                Address
              </strong>
              <br/>
              {{ data.address1_Line1 }}@if (data.address1_Line2) {
              <span>, {{ data.address1_Line2 }}</span>
            }
            {{ data.address1_City }}, {{ data.address1_StateOrProvince }} {{ data.address1_PostalCode }}
          </mat-label>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <mat-label>
            <strong>
              County
            </strong>
            <br/>
            {{ data.address1_County }}
          </mat-label>
        </div>
      </div>
    </div>
  </div>
  <div mat-dialog-actions class="row">
    <div class="col-md-12">
      <button
        mat-raised-button
        (click)="onClickClose()">
        NO
      </button>
      <button
        mat-raised-button
        [mat-dialog-close]="data"
        cdkFocusInitial>
        CONFIRM
      </button>
    </div>
  </div>
</div>
</div>
